import styled from "styled-components";
import {
  getBorderRadius,
  getColor,
  getFadeInAnimation,
  getSize,
  responsive,
} from "~/helpers/style";
import { UIProps } from "~/types/style";

interface IModal extends UIProps {
  padding?: string;
  minWidth: string | number;
  maxHeight?: string;
  overflow?: string;
}

interface IModalWrapper extends UIProps {
  backgroundBlur?: number;
}

export const ModalWrapper = styled.div<IModalWrapper & { bgImage?: string }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: ${({ bgImage }) =>
      bgImage
        ? `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${bgImage}) center/cover no-repeat`
        : "rgba(0, 0, 0, 0.5)"};
    filter: blur(${({ backgroundBlur }) => backgroundBlur}px);
    z-index: -1; /* Ensure it stays behind modal content */
  }

  ${getFadeInAnimation(0.3)}
`;

export const ModalContent = styled.div<IModal>`
  clip-path: inset(0px round ${getBorderRadius(1.2)});
  position: fixed;
  background: white;
  height: auto;
  top: 50%;
  left: 50%;
  width: 95%;
  transform: translate(-50%, -50%);
  border-radius: ${getBorderRadius(1.2)};
  max-height: ${({ maxHeight }) => (maxHeight ? maxHeight : "80%")};
  max-width: ${({ maxWidth }) => (maxWidth ? maxWidth : "")};
  overflow: ${({ overflow }) => overflow};
  padding: ${({ padding }) => (padding ? padding : getSize(3.2))};

  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for Firefox */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */

  ${responsive("tablet")} {
    width: auto;
    min-width: ${({ minWidth }) => minWidth};
    padding: ${({ padding }) => (padding ? padding : getSize(5.8))};
  }
`;

export const CloseContainer = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;

  padding: ${getSize(1.2)};
  ${responsive("tablet")} {
    padding: ${getSize(1.2)};
  }
`;

export const FixedElement = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${getColor("background")};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  z-index: 3;
`;
